import { useMutation } from "@tanstack/react-query";

import { MutationOptions } from "./types";

import { createSection, SectionRequestDto } from "@client";

export function useCreateSectionMutation(options?: MutationOptions) {
  return useMutation(async (input: SectionRequestDto) => createSection(input), {
    onSuccess: () => {
      options?.onSuccess && options.onSuccess();
    },
  });
}
